import { Fragment } from "react"
import { useField } from "formik"
import { Divider, Stack, Typography } from "@mui/material"
import { CreateUpdateBookingResourceTableSetups } from "../createUpdateBookingTypes"
import { ResourceItem } from "../../../createOrder/createOrderTypes"
import { SelectSetup } from "./SelectSetup"

type MeetingDetailsTableSettingProps = Readonly<{
    resourcesList: ResourceItem[]
}>

export function MeetingDetailsTableSetting({ resourcesList }: MeetingDetailsTableSettingProps) {
    const [{ value: resourcesValue }, , helpers] = useField<CreateUpdateBookingResourceTableSetups[]>("resources")

    const handleUpdateTableSetups = (resourceId: number, selectedTableSetups: string[]) => {
        const resourceExists = resourcesValue.some((r) => r.id === resourceId)

        const updatedResources = resourceExists
            ? resourcesValue.map((resource) =>
                  resource.id === resourceId
                      ? { ...resource, tableSetups: selectedTableSetups.map((key) => ({ key })) }
                      : resource,
              )
            : [...resourcesValue, { id: resourceId, tableSetups: selectedTableSetups.map((key) => ({ key })) }]

        helpers.setValue(updatedResources)
    }

    return (
        <Stack gap="1rem">
            {resourcesList?.map((el, index) => (
                <Fragment key={el.id}>
                    <Stack alignItems="center" flexDirection="row" gap="1rem" justifyContent="space-between">
                        <Typography variant="body1">{el.title}</Typography>
                        {el.tableSetups && (
                            <SelectSetup
                                tableSetups={el.tableSetups}
                                selectedSetups={
                                    resourcesValue.find((r) => r.id === +el.id)?.tableSetups?.map((ts) => ts.key) || []
                                }
                                onChange={(selected) => handleUpdateTableSetups(+el.id, selected)}
                            />
                        )}
                    </Stack>
                    {index !== resourcesList.length - 1 && <Divider />}
                </Fragment>
            ))}
        </Stack>
    )
}
